var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { DraftType, ExcelDraftUpdateType } from "@@/Draft";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { observable, action, makeObservable } from "mobx";
import { DiagramPropertyState } from "@/app/UIComponents/DiagramPropertyDialog";
import { DiagramPropertyPaneState } from "@/app/UIComponents/DiagramPrpertyPane";
import streamSaver from "streamsaver";
import { ObjectUpdateType } from "@/share/models";
import { ALLViewer, AnnotationType, NoteStatus, NoteType } from "@@/Annotation";
import { CommentState } from "@/app/UIComponents/Comments";
import { ColorStore } from "@/app/UIComponents/ColorDialog";
import { AccessGroupState } from "@/app/uistore/AccessgroupState";
import { EncryptBox } from "@@/EncryptBox";
import { SelectMemberDialogState } from "@/app/UIComponents/SelectMemberDialog";
export class AdminFloatingDraftViewStore {
    constructor() {
        this.loadingdetails = false;
        this.edittingrequest = false;
        this.showexpendedview = false;
        this.showdraftingview = false;
        this.savingdraft = false;
        this.lockupdating = false;
        this.lockerror = "";
        this.publishing = false;
        this.processpaste = false;
        this.viewing = false;
        this.scrollnoteid = "";
        this.view = "detail";
        this.exportstatus = new Map();
        this.exportstatusdetail = false;
        this.savingnote = false;
        this.drafttype = DraftType.DOCX;
        this.diagramPropertyState = new DiagramPropertyState();
        this.diagrapmpropertypanel = new DiagramPropertyPaneState();
        this.showpropertybox = false;
        this.loading = false;
        this.loadingcomments = false;
        this.deletingnote = false;
        this.lastnotesupdatetime = -1;
        this.linkingmode = false;
        this.notesbyid = new Map();
        this.enableannotation = false;
        this.loadingcustomview = false;
        this.startnotes = false;
        this.miniview = false;
        this.startindex = "";
        this.endindex = "";
        this.selectedrange = "";
        this.activeaccessids = new Set([ALLViewer]);
        this.appliedaclstr = "---";
        this.editnoteid = "";
        this.editmode = false;
        this.showcomments = false;
        this.spreadhseetcreated = false;
        this.pendingcelldata = new Map();
        this.imageidmapping = new Map();
        this.draftidtoimageidmapping = new Map();
        this.activenoteid = "";
        this.initcelladdress = "";
        this.shrinking = false;
        this.lastcommenttime = -1;
        this.activerequestid = "";
        this.objectid = "";
        this.commentstate = new CommentState();
        this.pendingupdates = [];
        this.penidngupdatesid = [];
        this.updateinglocktimeout = -1;
        this.draftid = "";
        this.draftname = "";
        this.letrid = "";
        this.accesskey = "";
        this.cref = null;
        this.activeinitdraftcontent = "";
        this.spreadsheetref = null;
        this.dref = null;
        this.colorstate = new ColorStore();
        this.requestingexcelexport = false;
        this.deletenoteids = new Set();
        this.insertedimages = new Set();
        this.activetabid = "";
        this.activesheetid = "";
        this.updateslist = [];
        this.accessstorestate = new AccessGroupState();
        this.readonlymode = false;
        this.lastdeltaupdatetime = -1;
        this.deltatimeout = -1;
        this.lastdelatid = "";
        this.draftview = true;
        this.showdeletebtn = false;
        this.updating = false;
        this.left = -100;
        this.top = -100;
        this.clickedid = "";
        this.smstate = new SelectMemberDialogState();
        this.shownotespanel = true;
        this.activeuserid = "";
        this.activdatasheet = null;
        window.addEventListener("mousedown", (e) => {
            const tgt = e.target;
            const npos = tgt.getAttribute("delete-btn");
            if (npos) {
                return;
            }
            const pt = tgt.parentElement;
            if (pt && pt.getAttribute("delete-btn")) {
                return;
            }
            this.setShowDeleteBtn(false);
        });
        window.addEventListener("touchstart", (e) => {
            const tgt = e.target;
            const npos = tgt.getAttribute("delete-btn");
            if (npos) {
                return;
            }
            const pt = tgt.parentElement;
            if (pt && pt.getAttribute("delete-btn")) {
                return;
            }
            this.setShowDeleteBtn(false);
        });
        this.colorstate.setLeftPos(window.innerWidth - 400);
        this.colorstate.setColor("rgba(211,211,211,.3)");
        makeObservable(this);
        APPEvent.addSubscriberForAdminSpreadsheetCont((con) => {
            if (con.floating && con.userid === this.activeuserid) {
                this.activeinitdraftcontent = con.content;
                this.setReadonlyMode(con.readonly);
            }
        });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            if (this.letrid !== letr.id) {
                this.letrid = letr.id;
                this.resetNotes();
            }
        });
        APPEvent.addSubscriberForPdfFilePage((res) => {
            if (!res.ischooser) {
                return;
            }
            if (res.pagename === 'viewer') {
                let page = "";
                if (res.page !== undefined) {
                    page = LetrwingCrypto.fromBase64ToUTF8(LetrwingCrypto.fromBase64ToUTF8(res.page));
                }
                this.activeinitdraftcontent = page;
            }
        });
        APPEvent.addSubscriberForAdminGetNote((notes) => {
            if (!notes.ischooser || notes.userid !== this.activeuserid) {
                return;
            }
            if (notes.letrid === this.letrid && notes.objectid === this.objectid) {
                notes.note.forEach((n) => {
                    if (n.status === NoteStatus.Dead) {
                        this.removeNote(n.id);
                    }
                    else {
                        this.addNote(n);
                    }
                });
                this.setLoadingNotes(false);
                this.scrollToNote();
                // this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
            }
        });
        APPEvent.addSubscriberForSaveNote((sn) => {
            if (sn.letrid === this.letrid && sn.objectid === this.objectid && sn.reqid === this.activerequestid) {
                if (sn.note) {
                    this.addNote(sn.note);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add note");
                }
                this.setSavingNote(false);
                this.setStartNotes(false);
                this.setShowComments(false);
                this.commentstate.clear();
            }
        });
        APPEvent.addSubscriberForDraftDetail((det) => {
            if (!(det === null || det === void 0 ? void 0 : det.isChooser)) {
                return;
            }
            if ((det === null || det === void 0 ? void 0 : det.draftid) === this.draftid) {
                if (det.detail === undefined) {
                    APPEvent.publishApperror("Sorry, failed to load draft details");
                }
                else {
                    this.setDraftDetail(det.detail);
                }
                this.setLoadingDetails(false);
                this.requestView();
            }
        });
        APPEvent.addSubscriberForDraftUpdates((ups) => {
            if (this.deltatimeout) {
                clearTimeout(this.deltatimeout);
            }
            this.decryptDraftUpdatesAndUpdateUI(ups);
            this.deltatimeout = setTimeout(() => this.monitorForDeltas(), 5000);
        });
        APPEvent.addSubscriberForDraftLockResponse((res) => {
            var _a, _b, _c, _d;
            if (!res.ischooser) {
                return;
            }
            if (this.edittingrequest && res.draftid === this.draftid) {
                if (res.res === undefined) {
                    this.setEdittingRequest(false);
                    APPEvent.publishApperror("Sorry, something went wrong getting edit lock. Please try again later");
                    return;
                }
                if (this.drafttype === DraftType.XLSX) {
                    try {
                        (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.clear({ type: 'Clear All' });
                    }
                    catch (ex) { }
                }
                if (res.res.granted) {
                    this.setReadonlyMode(false);
                    // now we can just edit this now!
                    // get the latest content and we done here!
                    if (res.res.decryptedcontent) {
                        if (this.drafttype === DraftType.XLSX) {
                            res.res.decryptedcontent = LetrwingCrypto.getUTF8FromBase64(res.res.decryptedcontent);
                        }
                        this.activeinitdraftcontent = res.res.decryptedcontent;
                    }
                    else {
                        this.activeinitdraftcontent = "";
                    }
                    this.lastdeltaupdatetime = (_b = res.res.lastupdatedtime) !== null && _b !== void 0 ? _b : 0;
                    this.setUpdating(true);
                    this.decryptDraftUpdatesAndUpdateUI(res.res.updates);
                    this.setShowDraftingView(true);
                    this.setMiniView(false);
                    if (res.res.updates.length > 100) {
                        setTimeout(() => this.checkAndShrinkSheet(), 500);
                    }
                    this.deltatimeout = setTimeout(() => this.monitorForDeltas(), 5000);
                    this.updateinglocktimeout = setTimeout(() => this.lockPing(), 10000);
                }
                else if (res.res.currentlockusername) {
                    APPEvent.publishApperror("Sorry, " + res.res.currentlockusername + " is editting this document. Please request them to release the edit lock");
                    return;
                }
                else {
                    APPEvent.publishApperror("Sorry, something went wrong getting edit lock. Please try again later");
                    return;
                }
                this.setEdittingRequest(false);
            }
            else if (this.viewing && res.draftid === this.draftid) {
                if (this.drafttype === DraftType.XLSX) {
                    this.setViewingRequest(false);
                    this.setReadonlyMode(true);
                }
                if (res.res === undefined) {
                    APPEvent.publishApperror("Sorry, something went wrong getting content. Please try again later");
                    return;
                }
                if (res.res.decryptedcontent) {
                    if (this.drafttype === DraftType.XLSX) {
                        res.res.decryptedcontent = LetrwingCrypto.getUTF8FromBase64(res.res.decryptedcontent);
                    }
                    this.activeinitdraftcontent = res.res.decryptedcontent;
                }
                else {
                    this.activeinitdraftcontent = "";
                }
                if (this.drafttype === DraftType.DOCX) {
                    if (this.cref) {
                        (_c = this.cref) === null || _c === void 0 ? void 0 : _c.documentEditor.open(this.activeinitdraftcontent);
                    }
                    this.setViewingRequest(false);
                    this.setReadonlyMode(true);
                }
                else if (this.drafttype === DraftType.Diagram) {
                    if (this.dref) {
                        this.dref.loadDiagram(this.activeinitdraftcontent);
                    }
                    this.setViewingRequest(false);
                    this.setReadonlyMode(true);
                }
                this.lastdeltaupdatetime = (_d = res.res.lastupdatedtime) !== null && _d !== void 0 ? _d : 0;
                this.setUpdating(true);
                this.decryptDraftUpdatesAndUpdateUI(res.res.updates);
                if (res.res.updates.length > 100) {
                    setTimeout(() => this.checkAndShrinkSheet(), 500);
                }
                this.deltatimeout = setTimeout(() => this.monitorForDeltas(), 5000);
                if (!this.loadingcustomview) {
                    //  this.setShowDraftingView(true);
                }
                else {
                }
                this.setLoadingCustomView(false);
            }
        });
        APPEvent.addSubscriberForNoteDelete((req) => {
            if (req.type === ObjectUpdateType.Comment) {
                if (req.objectid === this.editnoteid) {
                    if (req.ok) {
                        this.commentstate.removeComment(req.id);
                    }
                    else {
                        APPEvent.publishApperror("Sorry, failed to delete the comment.");
                        this.commentstate.removeCommentFromDelete(req.id);
                    }
                }
                return;
            }
            if (this.deletenoteids.has(req.id)) {
                if (!req.ok) {
                    APPEvent.publishApperror("Sorry, failed to delete the note.");
                }
                else {
                    this.removeNote(req.id);
                }
                if (this.editnoteid === req.id) {
                    this.setEditMode(false);
                    this.setEditNoteId("");
                    this.setAppliedAclString("");
                    this.selectAccessids([ALLViewer]);
                }
                this.removeDeletingNote(req.id);
            }
        });
        APPEvent.addSubscriberForSaveComments((res) => {
            if (this.commentstate.sendingcomments.has(res.replaceid)) {
                this.commentstate.removeSendingComment(res.replaceid);
                if (res.comment !== undefined) {
                    this.commentstate.setComment(res.comment);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add comment");
                }
            }
        });
        APPEvent.addSubscriberForNoteUpdate((up) => {
            if (up.letrid === this.letrid && up.objectid === this.objectid) {
                /// we good to go here now!!
                let lastupdatetime = -1;
                for (const n of up.notes) {
                    if (n.status !== NoteStatus.Dead) {
                        this.addNote(n);
                    }
                    else {
                        // delete this note that's all!
                        this.removeNote(n.id);
                    }
                    if (n.updatetime > lastupdatetime) {
                        lastupdatetime = n.updatetime;
                    }
                }
                if (lastupdatetime > -1) {
                    this.lastnotesupdatetime = lastupdatetime;
                }
                else {
                    this.lastnotesupdatetime = new Date().getTime();
                }
            }
        });
        APPEvent.addSubscriberForAdminGetComments((res) => {
            if (res.ischooser && res.userid === this.activeuserid && res.noteid === this.editnoteid) {
                // lets just add these now
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.commentstate.removeComment(com.id);
                    }
                    else {
                        this.commentstate.setComment(com);
                    }
                    if (com.updatetime > this.lastcommenttime) {
                        this.lastcommenttime = com.updatetime;
                    }
                });
                this.setLoadingComments(false);
            }
        });
        this.diagrapmpropertypanel.oncancel = () => {
            this.setShowPropertyPane(false);
        };
        this.diagrapmpropertypanel.onok = () => {
            var _a, _b, _c, _d;
            (_b = (_a = this.dref) === null || _a === void 0 ? void 0 : _a.selectedItems.nodes) === null || _b === void 0 ? void 0 : _b.forEach((node) => {
                var _a;
                // node.backgroundColor = this.diagramPropertyState.color;
                if (node.style) {
                    node.style.fill = this.diagrapmpropertypanel.color;
                    node.style.strokeColor = this.diagrapmpropertypanel.bordercolor;
                }
                (_a = node.annotations) === null || _a === void 0 ? void 0 : _a.forEach((ano) => {
                    if (ano.style) {
                        ano.style.color = this.diagrapmpropertypanel.textcolor;
                        ano.style.bold = this.diagrapmpropertypanel.boldtext;
                        ano.style.italic = this.diagrapmpropertypanel.italictext;
                        if (this.diagrapmpropertypanel.fontsize > 0) {
                            ano.style.fontSize = this.diagrapmpropertypanel.fontsize;
                        }
                        ano.style.textAlign = this.diagrapmpropertypanel.textalign;
                    }
                });
            });
            (_d = (_c = this.dref) === null || _c === void 0 ? void 0 : _c.selectedItems.connectors) === null || _d === void 0 ? void 0 : _d.forEach((conn) => {
                if (conn.style) {
                    conn.style.strokeColor = this.diagrapmpropertypanel.color;
                    conn.style.fill = this.diagrapmpropertypanel.color;
                }
            });
        };
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    saveComment(com) {
        var _a;
        if (this.editmode && this.editnoteid) {
            const savereq = {
                letrid: this.letrid,
                objectid: this.draftid,
                replaceid: com.id,
                text: (_a = com.datastr) !== null && _a !== void 0 ? _a : "",
                noteid: this.editnoteid
            };
            Apphandler.sendMessage("addcomment", savereq);
        }
    }
    showReadonlyMode() {
        // APPEvent.publishApperror("The document is in readonly mode. These changes won't be published");
    }
    updateImageData(add, userid) {
        let uid = this.imageidmapping.get(add.data.elemid);
        if (!uid) {
            uid = add.data.elemid;
        }
        if (!this.activetabid && this.readonlymode) {
            this.showReadonlyMode();
            return;
        }
        const data = {
            id: uid,
            letrid: this.letrid,
            draftid: this.draftid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origobjectid: this.objectid,
            userid: '',
            time: new Date().getTime(),
            update: LetrwingCrypto.secretBox(JSON.stringify(add), this.accesskey)
        };
        this.insertedimages.add(add.data.elemid);
        this.addSPreadsheetUpdate(data);
    }
    setUpdating(upd) {
        var _a, _b, _c;
        this.updating = upd;
        if (!upd) {
            this.setActiveSheetId((_c = ((_b = (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.getActiveSheet()) === null || _b === void 0 ? void 0 : _b.id) + '') !== null && _c !== void 0 ? _c : '');
        }
    }
    setMiniView(mini) {
        this.miniview = mini;
    }
    setLoadingCustomView(loading) {
        this.loadingcustomview = loading;
    }
    scrollToNote() {
        if (this.scrollnoteid && this.spreadsheetref && this.spreadhseetcreated && this.notesbyid.size > 0) {
            setTimeout(() => {
                var _a;
                if (this.scrollnoteid && this.spreadsheetref && this.notesbyid.size > 0) {
                    const n = this.notesbyid.get(this.scrollnoteid);
                    if (n) {
                        const parts = n.data.match.split(":");
                        let text = " ";
                        let totext = "";
                        let sindex = "";
                        let eindex = "";
                        let address = "";
                        if (parts.length > 2) {
                            try {
                                sindex = parts[1];
                                const en = parts[2];
                                const eparts = en.split(";");
                                eindex = eparts[0];
                                address = eparts[0] + ":" + eparts[1];
                                text += address;
                                const index = parseInt(sindex);
                                if (this.spreadsheetref.sheets.length >= index) {
                                    const name = this.spreadsheetref.sheets[index - 1].name;
                                    (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.goTo(name + "!" + eindex);
                                }
                                setTimeout(() => {
                                    var _a;
                                    (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.selectRange(address);
                                    this.setSelectedRange(address);
                                }, 100);
                            }
                            catch (ex) {
                                console.log(ex);
                            }
                        }
                    }
                    this.scrollnoteid = "";
                }
            }, 100);
        }
    }
    getActiveProjectObject() {
        const req = {
            letrid: this.letrid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origid: this.objectid,
        };
        Apphandler.sendMessage("getproject", req);
    }
    addGeneralObject(obj) {
        if (!this.activetabid && this.readonlymode) {
            this.showReadonlyMode();
            return;
        }
        const data = {
            id: '',
            letrid: this.letrid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origobjectid: this.objectid,
            draftid: this.draftid,
            userid: '',
            time: new Date().getTime(),
            update: LetrwingCrypto.secretBox(JSON.stringify(obj), this.accesskey)
        };
        this.addSPreadsheetUpdate(data);
    }
    storeImage(add, userid) {
        if (this.insertedimages.has(add.data.elemid)) {
            return;
        }
        if (!this.activetabid && this.readonlymode) {
            this.showReadonlyMode();
            return;
        }
        const time = new Date().getTime();
        const hash = LetrwingCrypto.hash512str(add.data.elemid + userid + time);
        this.imageidmapping.set(add.data.elemid, hash);
        this.draftidtoimageidmapping.set(hash, add.data.elemid);
        const data = {
            id: hash,
            letrid: this.letrid,
            draftid: this.draftid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origobjectid: this.objectid,
            userid: '',
            time: new Date().getTime(),
            update: LetrwingCrypto.secretBox(JSON.stringify(add), this.accesskey)
        };
        this.insertedimages.add(data.id);
        this.insertedimages.add(add.data.elemid);
        this.addSPreadsheetUpdate(data);
    }
    storeCell(add) {
        if (!this.activetabid && this.readonlymode) {
            this.showReadonlyMode();
            return;
        }
        const data = {
            id: '',
            letrid: this.letrid,
            draftid: this.draftid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origobjectid: this.objectid,
            userid: '',
            time: new Date().getTime(),
            update: LetrwingCrypto.secretBox(JSON.stringify(add), this.accesskey)
        };
        this.addSPreadsheetUpdate(data);
    }
    storeHyperlink(add) {
        if (!this.activetabid && this.readonlymode) {
            this.showReadonlyMode();
            return;
        }
        const data = {
            id: '',
            letrid: this.letrid,
            draftid: this.draftid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origobjectid: this.objectid,
            userid: '',
            time: new Date().getTime(),
            update: LetrwingCrypto.secretBox(JSON.stringify(add), this.accesskey)
        };
        this.addSPreadsheetUpdate(data);
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    setShowDeleteBtn(show) {
        this.showdeletebtn = show;
    }
    setCustomViewSheet() {
        var _a, _b;
        if (this.spreadhseetcreated) {
            return;
        }
        this.setSpreadsheetCreated(true);
        if (this.activeinitdraftcontent) {
            const obj = JSON.parse(this.activeinitdraftcontent);
            let workbook = obj;
            if (obj.jsonObject) {
                workbook = obj.jsonObject;
            }
            (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.openFromJson({ file: workbook });
            (_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.dataBound(() => {
                this.decryptpendingUpdates();
            });
        }
        else {
            this.decryptpendingUpdates();
        }
    }
    deleteActiveImage() {
        var _a, _b;
        this.setShowDeleteBtn(false);
        let aid = this.imageidmapping.get(this.clickedid);
        if (!aid) {
            aid = this.clickedid;
        }
        const ele = document.getElementById(this.clickedid);
        ele === null || ele === void 0 ? void 0 : ele.remove();
        this.imageidmapping.delete(this.clickedid);
        this.imageidmapping.delete(aid);
        this.draftidtoimageidmapping.delete(aid);
        this.draftidtoimageidmapping.delete(this.clickedid);
        const iupdate = {
            elemid: aid,
            src: '',
            width: 0,
            height: 0,
            sheetname: (_b = (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.getActiveSheet().name) !== null && _b !== void 0 ? _b : '',
            top: 0,
            left: 0,
            celladdress: ''
        };
        const add = {
            updatetype: ExcelDraftUpdateType.image,
            data: iupdate
        };
        const data = {
            id: aid,
            letrid: this.letrid,
            draftid: this.draftid,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origobjectid: this.objectid,
            userid: '',
            time: new Date().getTime(),
            update: LetrwingCrypto.secretBox(JSON.stringify(add), this.accesskey)
        };
        this.insertedimages.delete(aid);
        this.insertedimages.delete(this.clickedid);
        this.addSPreadsheetUpdate(data);
    }
    addEventsToImageId(id) {
        const ele = document.getElementById(id);
        if (ele) {
            ele.addEventListener("mouseup", (e) => {
                const box = ele.getBoundingClientRect();
                const lt = box.left + window.scrollX;
                const top = box.top + window.scrollY;
                const width = box.width;
                this.setLeft(lt + (width / 2));
                this.setTop(top - 27);
                this.clickedid = id;
                this.setShowDeleteBtn(true);
            });
            ele.addEventListener("touchend", () => {
                const box = ele.getBoundingClientRect();
                const lt = box.left + window.scrollX;
                const top = box.top + window.scrollY;
                const width = box.width;
                this.setLeft(lt + (width / 2));
                this.setTop(top - 27);
                this.setShowDeleteBtn(true);
                this.clickedid = id;
            });
        }
    }
    addSPreadsheetUpdate(up) {
        Apphandler.sendMessage("adddraftupdate", up);
    }
    setSpreadsheetCreated(created) {
        this.spreadhseetcreated = created;
        this.scrollToNote();
    }
    setSelectedRange(ran) {
        this.selectedrange = ran;
    }
    removeDeletingNote(dn) {
        this.deletenoteids.delete(dn);
    }
    setDeletingNote(dn) {
        this.deletenoteids.add(dn);
    }
    setShowComments(dn) {
        this.showcomments = dn;
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    deleteComment(id) {
        const req = {
            letrid: this.letrid,
            objectid: this.editnoteid,
            id: id
        };
        Apphandler.sendMessage("deletecomment", req);
    }
    deleteEditNote(nid) {
        const req = {
            letrid: this.letrid,
            objectid: this.draftid,
            id: nid
        };
        this.setDeletingNote(nid);
        Apphandler.sendMessage("deletenote", req);
    }
    setSavingNote(saving) {
        this.savingnote = saving;
    }
    removeNote(nid) {
        this.notesbyid.delete(nid);
    }
    setAppliedAclString(str) {
        this.appliedaclstr = str;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    formatPaste(cont) {
        this.setPasteProcessing(true);
        Apphandler.sendMessage("formatpaste", cont);
    }
    getAllNotes() {
        if (this.loading) {
            return;
        }
        this.lastnotesupdatetime = -1;
        this.setLoadingNotes(true);
        const req = {
            letrid: this.letrid,
            objectid: this.objectid,
            referencid: this.draftid,
            ischooser: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetnotes", req);
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
    }
    addNote(note) {
        this.notesbyid.set(note.id, note);
    }
    setEnableAnnotation(enable) {
        this.enableannotation = enable;
    }
    setStartNotes(start) {
        this.startnotes = start;
    }
    async decryptpendingUpdates() {
        let index = 0;
        for (const pu of this.pendingupdates) {
            this.checkAndUpdateDraftUpdates(pu, this.penidngupdatesid[index]);
            index++;
        }
        if (index > 0 && this.draftview) {
            //this.spreadsheetref?.refresh(false);
            /*setTimeout(() => {
                this.hideShowMenu?.();
            }, 100);*/
        }
        this.pendingupdates = [];
        this.penidngupdatesid = [];
        this.setUpdating(false);
        if (this.activenoteid) {
            const n = this.notesbyid.get(this.activenoteid);
            if (!n) {
                return;
            }
            const parts = n.data.match.split(":");
            let sindex = "";
            let eindex = "A1";
            let address = "";
            if (parts.length > 2) {
                try {
                    sindex = parts[1];
                    const en = parts[2];
                    const eparts = en.split(";");
                    if (eparts.length > 1) {
                        eindex = eparts[0];
                        address = eparts[0] + ":" + eparts[1];
                    }
                    else {
                        address = "";
                    }
                }
                catch (ex) { }
            }
            if (sindex === '') {
                return;
            }
            setTimeout(() => {
                var _a;
                try {
                    this.startindex = sindex;
                    this.endindex = eindex;
                    this.setEditMode(true);
                    this.setEditNoteId(n.id);
                    this.setAppliedAclString(n.aclstr);
                    this.selectAccessids(n.viewer);
                    (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.goTo(sindex + "!" + eindex);
                    if (address && address.indexOf(":") !== -1)
                        setTimeout(() => {
                            var _a;
                            (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.selectRange(address);
                            this.setSelectedRange(address);
                        }, 100);
                }
                catch (ex) { }
            }, 100);
        }
    }
    checkAndUpdateDraftUpdates(up, id) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        try {
            if (!this.spreadhseetcreated) {
                this.penidngupdatesid.push(id);
                this.pendingupdates.push(up);
            }
            else {
                const ddata = JSON.parse(up);
                if (ddata.updatetype === ExcelDraftUpdateType.hyperlink) {
                    const hdata = JSON.parse(up);
                    const address = hdata.data.sheetname + "!" + hdata.data.celladdress;
                    const info = (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.getAddressInfo(address);
                    if (info === null || info === void 0 ? void 0 : info.indices) {
                        const sheets = (_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.sheets;
                        let found = false;
                        for (const sheet of sheets !== null && sheets !== void 0 ? sheets : []) {
                            if (sheet.name === hdata.data.sheetname) {
                                found = true;
                                if (sheet.rows && sheet.rows.length > info.indices[0]) {
                                }
                                else {
                                    (_c = this.spreadsheetref) === null || _c === void 0 ? void 0 : _c.insertRow(info.indices[0], info.indices[2]);
                                }
                                break;
                            }
                        }
                        if (found) {
                            try {
                                // this.spreadsheetref?.updateCell({ value: '' }, address);
                                // this.spreadsheetref?.addHyperlink(hdata.data.link, address, hdata.data.name, true);
                            }
                            catch (ex) {
                                console.log(ex);
                            }
                        }
                    }
                }
                else if (ddata.updatetype === ExcelDraftUpdateType.image) {
                    const hdata = JSON.parse(up);
                    if (this.insertedimages.has(id) || this.insertedimages.has(hdata.data.elemid)) {
                        // lets get actual id
                        let aid = this.draftidtoimageidmapping.get(id);
                        if ((!aid)) {
                            aid = id;
                        }
                        this.draftidtoimageidmapping.delete(id);
                        const ele = document.getElementById(id);
                        if (ele) {
                            ele.remove();
                        }
                        // now lets get the elemid stuf!!
                        if (!hdata.data.src) {
                            return;
                        }
                        else {
                            // lets now update this!
                        }
                    }
                    if (!hdata.data.src || !hdata.data.celladdress) {
                        return;
                    }
                    const address = hdata.data.sheetname + "!" + hdata.data.celladdress;
                    const info = (_d = this.spreadsheetref) === null || _d === void 0 ? void 0 : _d.getAddressInfo(address);
                    if (!(info === null || info === void 0 ? void 0 : info.indices)) {
                        return;
                    }
                    const sheets = (_e = this.spreadsheetref) === null || _e === void 0 ? void 0 : _e.sheets;
                    let found = false;
                    for (const sheet of sheets !== null && sheets !== void 0 ? sheets : []) {
                        if (sheet.name === hdata.data.sheetname) {
                            found = true;
                            if (sheet.rows && sheet.rows.length > info.indices[0]) {
                            }
                            else {
                                (_f = this.spreadsheetref) === null || _f === void 0 ? void 0 : _f.insertRow(info.indices[0], info.indices[2]);
                            }
                            break;
                        }
                    }
                    if (found) {
                        try {
                            this.insertedimages.add(id);
                            this.insertedimages.add(hdata.data.elemid);
                            //  this.spreadsheetref?.updateCell({ value: '' }, address);
                            const iobj = {
                                src: hdata.data.src,
                                height: hdata.data.height,
                                width: hdata.data.width,
                                id: id,
                                // imageId: id,
                            };
                            if (hdata.data.top > -1) {
                                iobj.top = hdata.data.top;
                            }
                            if (hdata.data.left > -1) {
                                iobj.left = hdata.data.left;
                            }
                            (_g = this.spreadsheetref) === null || _g === void 0 ? void 0 : _g.insertImage([iobj], address);
                        }
                        catch (ex) {
                            console.log(ex);
                        }
                    }
                }
                else if (ddata.updatetype === ExcelDraftUpdateType.general) {
                    const hdata = JSON.parse(up);
                    (_h = this.spreadsheetref) === null || _h === void 0 ? void 0 : _h.updateAction(hdata.data);
                }
                else if (ddata.updatetype === ExcelDraftUpdateType.cell) {
                    const hdata = JSON.parse(up);
                    // lets clear cell hyherlink
                    try {
                        (_j = this.spreadsheetref) === null || _j === void 0 ? void 0 : _j.removeHyperlink(hdata.data.celladdress);
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                    const info = (_k = this.spreadsheetref) === null || _k === void 0 ? void 0 : _k.getAddressInfo(hdata.data.celladdress);
                    if (!(info === null || info === void 0 ? void 0 : info.indices)) {
                        return;
                    }
                    const smodel = (_l = this.spreadsheetref) === null || _l === void 0 ? void 0 : _l.sheets;
                    let amodel = undefined;
                    for (const sm of smodel !== null && smodel !== void 0 ? smodel : []) {
                        if (sm.name === hdata.data.sheetname) {
                            amodel = sm;
                            break;
                        }
                    }
                    if (amodel) {
                        let cmodel = (_m = this.getcell) === null || _m === void 0 ? void 0 : _m.call(this, info.indices[0], info.indices[1], amodel);
                        try {
                            (_o = this.setcell) === null || _o === void 0 ? void 0 : _o.call(this, info.indices[0], info.indices[1], amodel, {
                                value: hdata.data.name,
                                format: hdata.data.format,
                                formula: hdata.data.formula,
                                style: cmodel === null || cmodel === void 0 ? void 0 : cmodel.style,
                            });
                            (_p = this.spreadsheetref) === null || _p === void 0 ? void 0 : _p.updateCell({
                                value: hdata.data.name,
                                format: hdata.data.format,
                                formula: hdata.data.formula,
                                style: cmodel === null || cmodel === void 0 ? void 0 : cmodel.style,
                            }, hdata.data.celladdress);
                        }
                        catch (ex) {
                            console.log(ex);
                        }
                    }
                    else {
                        console.log("issue here?");
                    }
                    try {
                        //    this.spreadsheetref?.removeHyperlink(hdata.data.celladdress);
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                }
            }
        }
        catch (ex) { }
    }
    decryptDraftUpdatesAndUpdateUI(updates) {
        updates.sort((u1, u2) => u1.time - u2.time).forEach((up, index) => {
            try {
                const data = LetrwingCrypto.decryptSecretBox(up.update, this.accesskey);
                if (data) {
                    // now we have this data lets 
                    const utfstr = data;
                    if (this.drafttype === DraftType.XLSX) {
                        this.checkAndUpdateDraftUpdates(utfstr, up.id);
                        if (up.time > this.lastdeltaupdatetime) {
                            this.lastdeltaupdatetime = up.time;
                            this.lastdelatid = up.id;
                        }
                    }
                }
            }
            catch (ex) {
                console.log(ex);
            }
        });
    }
    async checkAndShrinkSheet() {
        var _a, _b, _c;
        if (this.drafttype === DraftType.XLSX && !this.shrinking) {
            //now lets check if we can shrink this
            this.shrinking = true;
            if (this.updateslist.length > 100) {
                (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.endEdit();
                const data = await ((_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.saveAsJson());
                const req = {
                    draftid: this.draftid,
                    letrid: this.letrid,
                    contentupdatetime: new Date().getTime() - (10 * 60 * 1000),
                    accesskey: this.accesskey,
                    content: LetrwingCrypto.getBase64FromUT8((_c = JSON.stringify(data)) !== null && _c !== void 0 ? _c : '')
                };
                Apphandler.sendMessage("savedraftcontet", req);
            }
        }
        this.shrinking = false;
    }
    monitorForDeltas() {
        if (this.drafttype === DraftType.XLSX) {
            const up = {
                letrid: this.letrid,
                objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
                origobjectid: this.objectid,
                draftid: this.draftid,
                time: this.lastdeltaupdatetime,
                id: this.lastdelatid,
                update: new EncryptBox(),
                userid: ""
            };
            Apphandler.sendMessage("montiordeltas", up);
            this.deltatimeout = setTimeout(() => this.monitorForDeltas(), 15000);
        }
    }
    saveEdit() {
        if (this.editmode && this.editnoteid) {
            // lets get the new two filed and that's all
            const enote = this.notesbyid.get(this.editnoteid);
            if (enote) {
                enote.aclstr = this.appliedaclstr;
                enote.viewer = Array.from(this.activeaccessids);
                enote.data.detail = [{ key: 'systemtext', value: '' }];
                this.setSavingNote(true);
                this.activerequestid = enote.id;
                const req = {
                    reqid: this.activerequestid,
                    letrid: this.letrid,
                    objectid: this.objectid,
                    note: enote,
                    comment: []
                };
                Apphandler.sendMessage("updatenote", req);
            }
        }
    }
    getActiveMarking() {
        var _a;
        const sindex = this.endindex.replace(":", ";");
        const marking = "docdraft:" + ((_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.getActiveSheet().id) + ":" + sindex;
        return marking;
    }
    saveNote(save = true) {
        var _a, _b, _c;
        const sindex = this.endindex.replace(":", ";");
        if (this.drafttype === DraftType.XLSX) {
            this.startindex = (_b = ((_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.getActiveSheet().id) + '') !== null && _b !== void 0 ? _b : '';
        }
        const marking = "docdraft:" + this.startindex + ":" + sindex;
        const databox = {
            detail: [{ key: 'systemtext', value: '' }],
            notetype: AnnotationType.Freehand,
            boxes: [],
            match: marking,
            color: (_c = this.colorstate.color) !== null && _c !== void 0 ? _c : 'green',
            storekthickness: -1
        };
        const note = {
            id: "",
            data: databox,
            type: NoteType.Note,
            viewer: Array.from(this.activeaccessids),
            parentid: "",
            authorname: "",
            authorid: "",
            updatetime: 0,
            replycount: 0,
            aclstr: "---",
            notereference: this.draftid
        };
        if (!save) {
            return note;
        }
        this.activerequestid = Math.random() + "";
        const req = {
            reqid: this.activerequestid,
            letrid: this.letrid,
            objectid: this.objectid,
            note: note,
            comment: this.commentstate.getComments()
        };
        Apphandler.sendMessage("savenote", req);
        this.setSavingNote(true);
        return note;
    }
    setLoadingNotes(loading) {
        this.loading = loading;
    }
    loadDraftDetail(silent = false) {
        if (this.loadingdetails) {
            return;
        }
        this.setMiniView(true);
        if (!silent) {
            this.setLoadingDetails(true);
        }
        this.setUpdating(false);
        // now lets 
        const req = {
            letrid: this.letrid,
            draftid: this.draftid,
            accesskey: this.accesskey,
            ischooser: true
        };
        Apphandler.sendMessage("draftdetails", req);
    }
    requestView() {
        if (this.viewing || this.edittingrequest) {
            return;
        }
        this.setViewingRequest(true);
        const req = {
            letrid: this.letrid,
            id: this.draftid,
            accesskey: this.accesskey,
            readonlymode: true,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origid: this.objectid,
            isChooser: true
        };
        Apphandler.sendMessage("draftedit", req);
    }
    loadComments() {
        if (this.loadingcomments || !this.editnoteid) {
            return;
        }
        this.setLoadingComments(true);
        const getcoom = {
            letrid: this.letrid,
            objectid: this.objectid,
            noteid: this.editnoteid,
            userid: this.activeuserid,
            floating: true
        };
        Apphandler.sendMessage("admingetcomments", getcoom);
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (!mode) {
            this.activeaccessids = new Set([ALLViewer]);
            this.appliedaclstr = "---";
        }
    }
    setEditNoteId(id) {
        this.editnoteid = id;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.loadComments();
        this.lastcommenttime = -1;
    }
    setActiveSheetId(id) {
        this.activesheetid = id;
    }
    resetNotes() {
        this.imageidmapping.clear();
        this.draftidtoimageidmapping.clear();
        this.insertedimages.clear();
        this.pendingupdates = [];
        this.penidngupdatesid = [];
        this.notesbyid.clear();
        this.setEnableAnnotation(false);
        this.setSelectedRange("");
        this.startindex = "";
        this.endindex = "";
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
        this.setSavingNote(false);
        this.setStartNotes(false);
        this.colorstate.setShow(false);
        this.setAppliedAclString("");
        this.selectAccessids([]);
        this.setShowComments(false);
        this.commentstate.clear();
    }
    getCommentUpdate() {
        if (this.loading || !this.letrid || !this.draftid || !this.editnoteid) {
            return;
        }
        const comms = this.commentstate.getComments();
        if (this.lastcommenttime == -1) {
            this.lastcommenttime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.letrid,
            objectid: this.objectid,
            since: this.lastcommenttime,
            noteid: this.editnoteid,
            referencid: this.draftid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getNotesUpdate() {
        this.getCommentUpdate();
        if (this.loading || !this.letrid || !this.draftid) {
            return;
        }
        if (this.lastnotesupdatetime === -1) {
            this.lastnotesupdatetime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.letrid,
            objectid: this.objectid,
            referencid: this.draftid,
            since: this.lastnotesupdatetime,
            updatetype: ObjectUpdateType.Note
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
        this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
    }
    requestEdit() {
        if (this.viewing || this.edittingrequest) {
            return;
        }
        this.spreadsheetref = null;
        this.setSpreadsheetCreated(false);
        this.pendingupdates = [];
        this.penidngupdatesid = [];
        this.activeinitdraftcontent = "";
        this.setEdittingRequest(true);
        this.setReadonlyMode(false);
        const req = {
            letrid: this.letrid,
            id: this.draftid,
            accesskey: this.accesskey,
            readonlymode: false,
            objectid: this.activetabid ? "tab-" + this.activetabid : this.objectid,
            origid: this.objectid
        };
        Apphandler.sendMessage("draftedit", req);
    }
    lockPing() {
        const req = {
            id: this.draftid,
            letrid: this.letrid
        };
        this.setLockUpdating(true);
        Apphandler.sendMessage("updateDraftLock", req);
        this.updateinglocktimeout = setTimeout(() => this.lockPing(), 10000);
    }
    async saveExcel() {
        var _a, _b, _c;
        this.setSavingDraft(true);
        (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.endEdit();
        const data = await ((_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.saveAsJson());
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: LetrwingCrypto.getBase64FromUT8((_c = JSON.stringify(data)) !== null && _c !== void 0 ? _c : '')
        };
        this.setSavingDraft(true);
        Apphandler.sendMessage("savedraftcontet", req);
    }
    async saveDiagram() {
        var _a;
        this.setSavingDraft(true);
        const diagram = (_a = this.dref) === null || _a === void 0 ? void 0 : _a.saveDiagram();
        this.activeinitdraftcontent = diagram !== null && diagram !== void 0 ? diagram : '';
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: diagram !== null && diagram !== void 0 ? diagram : ''
        };
        this.setSavingDraft(true);
        Apphandler.sendMessage("savedraftcontet", req);
    }
    saveContent() {
        var _a, _b;
        if (this.drafttype === DraftType.Diagram) {
            this.saveDiagram();
            return;
        }
        if (this.drafttype === DraftType.XLSX) {
            this.saveExcel();
            return;
        }
        const cont = (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.serialize();
        console.log((_b = this.cref) === null || _b === void 0 ? void 0 : _b.documentEditor.revisions);
        this.activeinitdraftcontent = cont !== null && cont !== void 0 ? cont : '';
        // lets now save this 
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: cont !== null && cont !== void 0 ? cont : ''
        };
        this.setSavingDraft(true);
        Apphandler.sendMessage("savedraftcontet", req);
    }
    setExportStatus(sta) {
        this.exportstatus.set(sta.id, sta);
    }
    getExportStatus() {
        this.setReqExportStatusDetails(true);
        this.exportstatus.clear();
        this.setView("exportmanager");
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            data: ""
        };
        Apphandler.sendMessage("draftexportstatus", req);
    }
    setReqExportStatusDetails(req) {
        this.exportstatusdetail = req;
    }
    setRequestingExportExcel(req) {
        this.requestingexcelexport = req;
    }
    setView(view) {
        this.view = view;
    }
    // for desktop this need to be slightly different 
    // maybe done via background
    async downloadData(data) {
        const bytes = LetrwingCrypto.base64ToBin(data);
        const fileStream = streamSaver.createWriteStream(this.draftname + ".xlsx", {
            size: bytes.length,
            writableStrategy: undefined,
            readableStrategy: undefined // (optional)
        });
        const writer = fileStream.getWriter();
        await writer.write(bytes);
        await writer.close();
    }
    async exportExcel() {
        var _a, _b;
        (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.endEdit();
        const data = await ((_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.saveAsJson());
        this.setRequestingExportExcel(true);
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            data: data ? LetrwingCrypto.getBase64FromUT8(JSON.stringify(data.jsonObject.Workbook)) : ''
        };
        Apphandler.sendMessage("draftexport", req);
    }
    getDiagramData() {
        var _a;
        return (_a = this.dref) === null || _a === void 0 ? void 0 : _a.exportDiagram({ fileName: this.draftname, format: 'PNG', mode: 'Data' });
    }
    exportDraft() {
        if (this.drafttype === DraftType.Diagram) {
            this.exportDiagram();
        }
        else if (this.drafttype === DraftType.DOCX) {
            this.exportDocx();
        }
        else if (this.drafttype === DraftType.XLSX) {
            this.exportExcel();
        }
    }
    exportDiagram() {
        var _a;
        const blob = (_a = this.dref) === null || _a === void 0 ? void 0 : _a.exportDiagram({ fileName: this.draftname, format: 'PNG', mode: 'Download' });
        if (typeof blob === 'string') {
            const link = document.createElement("a");
            link.href = blob;
            link.download = this.draftname + ".png";
            link.click();
        }
    }
    exportDocx() {
        var _a;
        (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.save(this.draftname, "Docx");
    }
    publishDraft() {
        var _a;
        const cont = (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.serialize();
        // lets now save this 
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: cont !== null && cont !== void 0 ? cont : ''
        };
        this.setPublishing(true);
        Apphandler.sendMessage("publishdraftcontent", req);
    }
    setPasteProcessing(processing) {
        this.processpaste = processing;
    }
    setShowPropertyPane(show) {
        this.showpropertybox = show;
    }
    setPublishing(publishing) {
        this.publishing = publishing;
    }
    setLockUpdating(updating) {
        this.lockupdating = updating;
    }
    setLockError(error) {
        this.lockerror = error;
    }
    setSavingDraft(saving) {
        this.savingdraft = saving;
    }
    setShowExapndedView(expand) {
        this.showexpendedview = expand;
    }
    setShowDraftingView(view) {
        this.showdraftingview = view;
        if (!view) {
            this.setLockUpdating(false);
            if (this.updateinglocktimeout !== -1) {
                clearTimeout(this.updateinglocktimeout);
            }
            if (this.deltatimeout !== -1) {
                clearTimeout(this.deltatimeout);
            }
            this.updateslist = [];
            this.pendingcelldata = new Map();
            this.pendingupdates = [];
            this.penidngupdatesid = [];
            this.imageidmapping.clear();
            this.insertedimages.clear();
        }
    }
    setEdittingRequest(req) {
        this.edittingrequest = req;
    }
    setViewingRequest(req) {
        this.viewing = req;
    }
    setReadonlyMode(readonlymode) {
        this.readonlymode = readonlymode;
    }
    setDraftDetail(detail) {
        this.details = detail;
    }
    setLoadingDetails(loadingdetails) {
        this.loadingdetails = loadingdetails;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "loadingdetails", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "details", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "edittingrequest", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "showexpendedview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "showdraftingview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "savingdraft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "lockupdating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "lockerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "publishing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "processpaste", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "viewing", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminFloatingDraftViewStore.prototype, "view", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDraftViewStore.prototype, "exportstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "exportstatusdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "savingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "showpropertybox", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "deletingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDraftViewStore.prototype, "notesbyid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "enableannotation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "loadingcustomview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "startnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "miniview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "selectedrange", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDraftViewStore.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminFloatingDraftViewStore.prototype, "appliedaclstr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "editnoteid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "spreadhseetcreated", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "requestingexcelexport", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDraftViewStore.prototype, "deletenoteids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "activesheetid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "readonlymode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "showdeletebtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "updating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDraftViewStore.prototype, "shownotespanel", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setUpdating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setMiniView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLoadingCustomView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setShowDeleteBtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setSpreadsheetCreated", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setSelectedRange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "removeDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setSavingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "removeNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setAppliedAclString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "addNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setEnableAnnotation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setStartNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setEditNoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setActiveSheetId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "resetNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "getExportStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setReqExportStatusDetails", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setRequestingExportExcel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setPasteProcessing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setShowPropertyPane", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setPublishing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLockUpdating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLockError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setSavingDraft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setShowExapndedView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setShowDraftingView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setEdittingRequest", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setViewingRequest", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setReadonlyMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setDraftDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDraftViewStore.prototype, "setLoadingDetails", null);
